import { gql } from '@apollo/client'

export type PartnerClientContext = 'agent' | 'lender'

export type PartnerClient = {
  leadId: string | null
  status: string | null
  borrowerName: string | null
  departingPropertyAddress1: string | null
  departingPropertyAddress2: string | null
  transactionId: string | null
  transactionType: string | null
}

export type PartnerClientsByPersonIdInput = {
  personId: number
  context: PartnerClientContext
  statusFilters?: string[]
}

export type PartnerClientsResponse = {
  partnerClientsByPersonId: Array<{
    leadId: string | null
    status: string | null
    borrower: { name: string | null } | null
    departingPropertyAddress1: string | null
    departingPropertyAddress2: string | null
    transactionId: string | null
    transactionType: string | null
  }> | null
}

/**
 * Lookup the partner clients (leads) Jupiter has for a person in a given
 * context. Backyard-only: requires an employee role on the backend.
 */
export const PARTNER_CLIENTS_BY_PERSON_ID = gql`
  query PartnerClientsByPersonId($input: PartnerClientsByPersonIdInput!) {
    partnerClientsByPersonId(input: $input) {
      leadId: lead_id
      status
      borrower {
        name
      }
      departingPropertyAddress1: departing_property_address_1
      departingPropertyAddress2: departing_property_address_2
      transactionId: transaction_id
      transactionType: transaction_type
    }
  }
`
